import { BaseType } from "../base/base-type";

const TabsStateLiteralList = ["STATS", "FORM", "RESULTS"] as const;

type TabsStateLiterals = (typeof TabsStateLiteralList)[number];

/**
 * 画面の表示状態を表す
 */
export class SurveyTabState extends BaseType<TabsStateLiterals> {
  static isValid(tab?: string): tab is TabsStateLiterals {
    return TabsStateLiteralList.indexOf(tab as TabsStateLiterals) !== -1;
  }

  static from(tab: TabsStateLiterals) {
    return new SurveyTabState(tab);
  }

  static initialize() {
    return new SurveyTabState("STATS");
  }

  static form() {
    return new SurveyTabState("FORM");
  }

  static results() {
    return new SurveyTabState("RESULTS");
  }
}
